const state = {
    value: '[{"source": {"vocItems": null}}]',
    mode: 'json',
};

const mutations = {
    UPDATE_MODE (state, mode) {
        state.mode = mode;
    },
    UPDATE_VALUE (state, value) {
        state.value = value;
    },
};

const actions = {
    updateMode ({ commit }, mode) {
        commit('UPDATE_MODE', mode);
    },
    updateValue ({ commit }, value) {
        commit('UPDATE_VALUE', value);
    },
};

const getters = {};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
